import React from "react";
import YouTube from "react-youtube";
import "./YoutubeEmbed.css";

import { useSearchTermContext } from "../../SearchTermContext";

const YoutubeEmbed = () => {
  const { searchTerm } = useSearchTermContext();
  // const [videoUrl, setVideoUrl] = React.useState("");
  let videoCode;
  if (searchTerm) {
    if (searchTerm.includes("v=") && searchTerm.includes("&")) {
      videoCode = searchTerm.split("v=")[1].split("&")[0];
    }
  }

  // const res = await axios.get(`https://meet.google.com/${videoCode}`);
  //   console.log(res);
  // let videoCode;
  // if (videoUrl) {
  //   videoCode = videoUrl.split("v=")[1].split("&")[0];
  // }

  const checkElapsedTime = (e) => {
    console.log(e.target.playerInfo.playerState);
    const duration = e.target.getDuration();
    const currentTime = e.target.getCurrentTime();
    if (currentTime / duration > 0.95) {
    }
  };

  const opts = {
    height: "390",
    width: "830",
    playerVars: {
      autoplay: 0,
    },
  };
  return (
    <div className="iframe-container">
      <div className="Embed">
        <YouTube
          videoId={videoCode}
          containerClassName="embed embed-youtube"
          onStateChange={(e) => checkElapsedTime(e)}
          opts={opts}
        />
      </div>
    </div>
  );
};

export default YoutubeEmbed;
